module.exports = __webpack_public_path__ + "img/face_gather6.3750bb34.png";